import React, {Component} from 'react';
import './header.css';
import menu from '../../img/menu.png';
import ubicar from '../../img/location.png';
import firebase from 'firebase';

class Header extends Component{
    constructor(props){
        super(props);
        this.state={
            ruta:''
        }
    }

    componentDidUpdate(prevProps){
        if (this.props.userViaj !== prevProps.userViaj) {
            let { userViaj } = this.props;
            if(userViaj!== null)
            {
                firebase.database().ref('Rutas/'+userViaj.ruta).once('value').then(snap =>{
                    let ruta = snap.val();
                    this.setState({ruta});
                })
            }
        }
    }

    render(){
        let { ruta } = this.state;
        return(
            <div className='princi' style={{width:'100%', height:'10%'}}>
                <div className='header' style={{width:'10%', height:'100%'}}>
                    
                </div>
                <div className='header' style={{width:'80%', height:'100%'}}>
                    <p className='centerT'>{ruta.nombRuta!== undefined?ruta.nombRuta:'Sin ruta asignada'}</p>
                </div>
                {/* <div className='header' style={{width:'10%', height:'100%'}}>
                    <img className='imgL' src={ubicar} alt="menu" />
                </div> */}
            </div>
        )
    }
}
export default Header;


// WEBPACK FOOTER //
// ./src/Components/config/Header.js